export default __webpack_public_path__ + "9076aa798c42257daa88155fc740e7e3.svg";